import { render, staticRenderFns } from "./ContractsGrid.vue?vue&type=template&id=12784762"
import script from "./ContractsGrid.vue?vue&type=script&lang=js"
export * from "./ContractsGrid.vue?vue&type=script&lang=js"
import style0 from "./ContractsGrid.vue?vue&type=style&index=0&id=12784762&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports